import { render, staticRenderFns } from "./website_detail.vue?vue&type=template&id=461abe73&scoped=true"
import script from "./website_detail.vue?vue&type=script&lang=js"
export * from "./website_detail.vue?vue&type=script&lang=js"
import style0 from "./website_detail.vue?vue&type=style&index=0&id=461abe73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461abe73",
  null
  
)

export default component.exports